import { Button } from "components/Button";
import { useEffect,useState } from "react";
import { Link,useLocation,} from "react-router-dom";

const Breadcrumbs = (props) => {
  const location = useLocation();

  const [isFullScreen, setFullScreen] = useState(false);


  useEffect(() => {
   

    const cleanup = () => {
      if (isFullScreen && document.exitFullscreen) {
        document.exitFullscreen();
        setFullScreen(false);
      }
    };

    // const maximizeBtn = maximizeBtnRef.current;
    // maximizeBtn?.addEventListener('click', handleClick);

    // Cleanup function to remove the event listener and exit fullscreen on component unmount
    return () => {
      // maximizeBtn?.removeEventListener('click', handleClick);
      cleanup();
    };
  }, [isFullScreen]);


  let addButton = null;
  if (
    location.pathname === "/form-basic-inputs" ||
    location.pathname === "/form-input-groups" ||
    location.pathname === "/form-horizontal" ||
    location.pathname === "/form-vertical" ||
    location.pathname === "/form-mask" ||
    location.pathname === "/form-validation" ||
    location.pathname === "/tables-basic" ||
    location.pathname === "/data-tables" ||
    location.pathname === "/performance" ||
    location.pathname === "/payments" ||
    location.pathname === "/ui/components" ||
    location.pathname === "/adminattendance" ||
    location.pathname === "/attendance-employee" ||
    location.pathname === "/task-board" ||
    location.pathname === "/leads" ||
    location.pathname === "/create-estimate" ||
    location.pathname === "/edit-estimate" ||
    location.pathname === "/create-invoice" ||
    location.pathname === "/edit-invoice" ||
    location.pathname === "/payments" ||
    location.pathname === "/payroll-items" ||
    location.pathname === "/activities" ||
    location.pathname === "/expense-reports" ||
    location.pathname === "/invoice-reports" ||
    location.pathname === "/payments-reports" ||
    location.pathname === "/task-reports" ||
    location.pathname === "/user-reports" ||
    location.pathname === "/payslip-reports" ||
    location.pathname === "/attendance-reports" ||
    location.pathname === "/user-dashboard" ||
    location.pathname === "/user-all-jobs" ||
    location.pathname === "/saved-jobs" ||
    location.pathname === "/interviewing" ||
    location.pathname === "/offered-jobs" ||
    location.pathname === "/visited-jobs" ||
    location.pathname === "/knowledgebase" ||
    location.pathname === "/questions" ||
    location.pathname === "/jobs-dashboard" ||   
    location.pathname === "/shortlist-candidates" ||
    location.pathname === "/offer_approvals" ||
    location.pathname === "/schedule-timing" ||
    location.pathname === "/apptitude-result" ||
    location.pathname === "/job-aptitude" ||
    location.pathname === "/applied-jobs" ||
    location.pathname === "/offered-jobs" ||
    location.pathname === "/archived-jobs" ||
    location.pathname === "/subscriptions-company" ||
    location.pathname === "/subscribed-companies" ||
    location.pathname === "/profile" ||
    location.pathname === "/job-list" ||
    location.pathname === "/job-view" ||
    location.pathname === "/search" ||
    location.pathname === "/faq" ||
    location.pathname === "/blank-page" ||
    location.pathname === "/user-asset-details" ||
    location.pathname === "/leaves-setting" ||
    location.pathname === "/project-reports" ||
    location.pathname === "/client-profile"
  ) {
    addButton = (
      <div className="row">
        <div className="col">
          <h3 className="page-title">{props.maintitle}</h3>
          {/* <ul className="breadcrumb">
            <li className="breadcrumb-item">
              <Link 
              to="#"
              >{props.title}</Link>
            </li>
            <li className="breadcrumb-item active">{props.subtitle}</li>
          </ul> */}
        </div>
      </div>
    );
  } else if (
    location.pathname === "/settings/company-settings" ||
    location.pathname === "/settings/localization" ||
    location.pathname === "/settings/theme-settings" ||
    location.pathname === "/settings/roles-permissions" ||
    location.pathname === "/settings/approval-setting" ||
    location.pathname === "/settings/invoice-settings" ||
    location.pathname === "/settings/salary-settings" ||
    location.pathname === "/settings/notifications-settings" ||
    location.pathname === "/settings/toxbox-setting" ||
    location.pathname === "/settings/cron-setting"
  ) {
    addButton = (
      <div className="row">
        <div className="col-sm-12">
          <h3 className="page-title">{props.maintitle}</h3>
        </div>
      </div>
    );
  } else if (location.pathname === "/admin-dashboard") {
    addButton = (
      <div className="row">
        <div className="col">
          <h3 className="page-title">{props.maintitle}</h3>
          <ul className="breadcrumb">
            <li className="breadcrumb-item active">{props.title}</li>
          </ul>
        </div>
      </div>
    );
  } else if (location.pathname === "/invoice-view") {
    addButton = (
      <div className="row">
        <div className="col">
          <h3 className="page-title">{props.maintitle}</h3>
          {/* <ul className="breadcrumb">
            <li className="breadcrumb-item">
              <Link
               to="#"
               >{props.title}</Link>
            </li>
            <li className="breadcrumb-item active">{props.subtitle}</li>
          </ul> */}
        </div>
        <div className="col-auto float-end ms-auto">
          <div className="btn-group btn-group-sm">
            <button className="btn btn-white">CSV</button>
            <button className="btn btn-white">PDF</button>
            <button className="btn btn-white">
              <i className="fa-solid fa-print fa-lg" /> Print
            </button>
          </div>
        </div>
      </div>
    );
  } else if (
    location.pathname === "/projects" ||
    location.pathname === "/clients" ||
    location.pathname === "/clients-list" ||
    location.pathname === "/project-list" ||
    location.pathname === "/employees" ||
    location.pathname === "/employees-list" ||
    location.pathname === "/company-directory" ||
    location.pathname === "/manage-jobs" ||
    location.pathname === "/assets" || 
    location.pathname === "/salary" ||
    location.pathname === "/manage-resumes" ||
    location.pathname === "/employee-referrals" ||

    location.pathname === "/documents" ||
    location.pathname === "/documents/store" ||
    location.pathname === "/uniforms" ||
    location.pathname === "/leaves-employee"||
    location.pathname === "/expenses"||
    location.pathname === "/holidays"||
    location.pathname === "/grades"||
    location.pathname === "/departments"||
    location.pathname === "/designations"||

    location.pathname === "/leave-planner"||
    location.pathname === "/resignations" ||
    location.pathname === "/job-drive-slots" ||
    location.pathname === "/job-drive-dashboard" ||
    location.pathname === "/job-drive-attendance" ||
    location.pathname === "/job-drive-scan" ||
    location.pathname.startsWith("/job-drive/")
  ) {
  
    addButton = (
      <div className="row align-items-center g-0">
        <div className="col">
          <h3 className="page-title">{props.maintitle}</h3>
          {/* <ul className="breadcrumb">
            <li className="breadcrumb-item">
              <Link 
              to="#"
              >{props.title}</Link>
            </li>
            <li className="breadcrumb-item active">{props.subtitle}</li>
          </ul> */}
        </div>
        <div className="col-auto" style={{ paddingRight: 0, marginRight: 0, display: "flex", alignItems: "center", gap: "12px" }}>
         
          {
            props.modal === "#add_job" || 
            props.modal === "#add_document" ||  
            props.modal === "#add_leave" || 
            props.modal === "#add_leave_plan" || 
            props.modal === "#add_expense" ||
             props.modal === "#add_uniform" ||
             props.modal === "#add_assets" ||
             props.modal === "#add_resignation" ||
             props.modal === "#add_slot"
             ?
            <button
            className="btn add-btn"
            // data-bs-toggle="modal"
            // data-bs-target={props.modal}
            onClick={
              ()=>{
                if(props.modal === "#add_job"){
                  props.setJobModal(true)
                }

                if(props.modal === "#add_document"){
                  props.setDocumentModal(true)
                }

                if(props.modal === "#add_leave"){
                  props.setLeaveModal(true)
                }
                if(props.modal === "#add_leave_plan"){
                  props.setLeavePlannerModal(true)
                }
                if(props.modal === "#add_expense"){
                  props.setExpenseModal(true)
                }
                if(props.modal === "#add_uniform"){
                  props.setUniformModal(true)
                }
                if(props.modal === "#add_assets"){
                  props.setAssetModal(true)
                }
                if(props.modal === "#add_resignation"){
                  console.log("------resignnnnnn")
                  props.setResignationModal(true)
                }
                if(props.modal === "#add_slot"){
                  props.setJobModal(true)
                }
              }
            }
          >
            <i className="fa fa-plus" /> {props.name}
          </button>
          :
          props.setJobModal ? (
            <button
              className="btn add-btn"
              onClick={() => props.setJobModal(true)}
            >
              <i className="fa fa-qrcode" /> {props.name}
            </button>
          ) : ""
        // <Link
        //     to="#"
        //     className="btn add-btn"
        //     data-bs-toggle="modal"
        //     data-bs-target={props.modal}
        //     onClick={
        //       ()=>{
        //         if(props.modal == "#add_job"){
        //           props.setJobModal(true)
        //         } 

        //         if(props.modal == "#add_document"){
        //           console.log(props, "---")
        //           props.setDocumentModal(true)
        //         }
        //         if(props.modal == "#add_leave"){
        //           props.setLeaveModal(true)
        //         }
        //       }
        //     }
        //   >
        //     <i className="fa fa-plus" /> {props.name}
        //   </Link>
          }
          
          {/* Add link to public job list for manage-jobs page */}
          {location.pathname === "/manage-jobs" && (
            <a
              href={`${window.location.origin}/job-view`}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-outline-primary"
              style={{ marginRight: "8px" }}
            >
              <i className="fa fa-external-link me-2" /> Job Portal
            </a>
          )}

          <div className="view-icons d-inline-flex" style={{ marginRight: 0, paddingRight: 0 }}>
            {/* {
              !props.hideGrid &&
              <>
             <Button onClick={()=>props.setView("grid")} icon="las la-th" className={`grid-view btn btn-link ${props.view=="grid"&&"active"} mx-2`}  />
            <Button onClick={()=>props.setView("list")} icon="las la-list" className={`list-view btn btn-link ${props.view=="list"&&"active"}`} />
              </>
            } */}

              {!props.hideGrid && (
                <Button
                  onClick={() => props.setView(props.view === "grid" ? "list" : "grid")}
                  icon={props.view === "grid" ? "las la-list" : "las la-th"}
                  className="btn btn-link"
                  style={{ marginRight: 0, paddingRight: 0, paddingLeft: 0 }}
                  title={`Click to View ${props.view === "grid" ? "List" : "Grid"}`}
                />
              )}


            {/* <Button onClick={handleClick} icon="las la-expand-arrows-alt" id="collapse-header" className="list-view btn btn-link"/> */}

            {/* <Link to="#" className="list-view btn btn-link" id="collapse-header" ref={maximizeBtnRef}>

<i className="las la-expand-arrows-alt" />
</Link> */}

           
          {/* <button to="/contact-grid" className={`grid-view btn btn-link ${props.view=="grid"&&"active"} mx-2`}>
                    <i className="las la-th" />
                  </button> */}
            {/* <button
              onClick={()=>props.setView("grid")}
              className={`grid-view btn btn-link ${props.view=="grid"&&"active"} mx-2`}
            >
              <i className="fa fa-th" />
            </button> */}
            {/* <button onClick={()=>props.setView("list")} className={`list-view btn btn-link ${props.view=="list"&&"active"}`}>
              <i className="fa fa-bars" />
            </button> */}
          </div>
        </div>
      </div>
    );
  } else if (
    location.pathname === "/estimates" ||
    location.pathname === "/invoices" 

    ) {
    addButton = (
      <div className="row align-items-center">
        <div className="col">
          <h3 className="page-title">{props.maintitle}</h3>
          {/* <ul className="breadcrumb">
            <li className="breadcrumb-item">
              <Link
               to="#"
              >{props.title}</Link>
            </li>
            <li className="breadcrumb-item active">{props.subtitle}</li>
          </ul> */}
        </div>
        <div className="col-auto float-end ms-auto">
          <Link
            to={props.link}
            className="btn add-btn"
            data-bs-target={props.modal}
          >
            <i className="fa fa-plus" />
            {props.name}
          </Link>
        </div>
      </div>
    );
  } else if (
    location.pathname === "/employee-reports" ||
    location.pathname === "/leave-reports" ||
    location.pathname === "/daily-reports"
  ) {
    addButton = (
      <div className="row align-items-center">
        <div className="col">
          <h3 className="page-title">{props.maintitle}</h3>
          {/* <ul className="breadcrumb">
            <li className="breadcrumb-item">
              <Link 
              to="#"
              >{props.title}</Link>
            </li>
            <li className="breadcrumb-item active">{props.subtitle}</li>
          </ul> */}
        </div>
        <div className="col-auto">
          <Link to="#" className="btn btn-primary">
            PDF
          </Link>
        </div>
      </div>
    );
  } else if (location.pathname === "/project-view") {
    addButton = (
      <div className="page-header">
        <div className="row align-items-center">
          <div className="col">
            <h3 className="page-title">{props.maintitle}</h3>
            {/* <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <Link 
                to="#"
                >{props.title}</Link>
              </li>
              <li className="breadcrumb-item active">{props.subtitle}</li>
            </ul> */}
          </div>
          <div className="col-auto float-end ms-auto">
            <Link
              to="#"
              className="btn add-btn"
              data-bs-toggle="modal"
              data-bs-target="#edit_project"
            >
              <i className="fa-solid fa-plus"></i> {props.add}
            </Link>
            <Link
              to={props.menu}
              className="btn btn-white float-end me-3"
              data-bs-toggle="tooltip"
              title="Task Board"
            >
              <i className="fa-solid fa-bars"></i>
            </Link>
          </div>
        </div>
      </div>
    );
  } else if (location.pathname === "/salary-view") {
    addButton = (
      <div className="row">
        <div className="col">
          <h3 className="page-title">{props.maintitle}</h3>
          {/* <ul className="breadcrumb">
            <li className="breadcrumb-item">
              <Link
              //  to="/"
              >{props.title}</Link>
            </li>
            <li className="breadcrumb-item active">{props.subtitle}</li>
          </ul> */}
        </div>
        <div className="col-auto float-end ms-auto">
          <div className="btn-group btn-group-sm">
            <button className="btn btn-white">CSV</button>
            <button className="btn btn-white">PDF</button>
            <button className="btn btn-white">
              <i className="fa fa-print fa-lg" /> Print
            </button>
          </div>
        </div>
      </div>
    );
  } else if (location.pathname === "/interview-questions") {
    addButton = (
      <div className="row align-items-center">
        <div className="col">
          <h3 className="page-title">{props.maintitle}</h3>
          {/* <ul className="breadcrumb">
            <li className="breadcrumb-item">
              <Link 
              // to="/"
              >{props.title}</Link>
            </li>
            <li className="breadcrumb-item active">{props.subtitle}</li>
          </ul> */}
        </div>
        <div className="col-auto float-end ms-auto">
          <Link
            to="#"
            className="btn add-btn "
            data-bs-toggle="modal"
            data-bs-target={props.modalone}
          >
            <i className="fa fa-plus" />
            {props.nameone}
          </Link>

          <Link
            to="#"
            className="btn add-btn me-2"
            data-bs-toggle="modal"
            data-bs-target={props.modaltwo}
          >
            <i className="fa fa-plus" />
            {props.nametwo}
          </Link>
        </div>
      </div>
    );
  } else {
    addButton = (
      <div className="row align-items-center">
        <div className="col">
          <h3 className="page-title">{props.maintitle}</h3>
          {/* <ul className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to={props?.linkName}>{props.title}</Link>
            </li>
            <li className="breadcrumb-item active">{props.subtitle}</li>
          </ul> */}
        </div>
        {
          props.showModal &&
          <div className="col-auto float-end ms-auto">
            <Link
              to="#"
              className="btn add-btn"
              data-bs-toggle="modal"
              data-bs-target={props.modal}
            >
              <i className="fa fa-plus" />
              {props.name}
            </Link>
          </div>
        }
        
      </div>
    );
  }
  return (
    <>
      <div className="page-header">{addButton}</div>
    </>
  );
};

export default Breadcrumbs;
